<template>
  <div class="sso-buttons">
    <div
      v-if="google"
      class="_btn"
    >
      <m-btn
        block
        :loading="loading === authMethod.ssoGoogle"
        @click="emit('google')"
      >
        <m-icon
          size="16"
          type="google-color"
          class="_icon"
        />
        {{ $t('login.viaGoogle') }}
      </m-btn>
    </div>
    <div
      v-if="microsoft"
      class="_btn"
    >
      <m-btn
        block
        :loading="loading === authMethod.ssoMicrosoft"
        @click="emit('microsoft')"
      >
        <m-icon
          size="16"
          type="microsoft-color"
          class="_icon"
        />
        {{ $t('login.viaMicrosoft') }}
      </m-btn>
    </div>
    <div
      v-if="saml"
      class="_btn"
    >
      <m-btn
        block
        :loading="loading === authMethod.saml"
        @click="emit('saml')"
      >
        <m-icon
          size="16"
          type="key"
          class="_icon"
        />
        {{ $t('login.viaSaml') }}
      </m-btn>
    </div>
  </div>
</template>

<script setup>
import { authMethod } from 'shared/constants.json';

defineProps({
  google: {
    type: Boolean,
    default: true,
  },
  microsoft: {
    type: Boolean,
    default: true,
  },
  saml: {
    type: Boolean,
    default: true,
  },
  loading: {
    type: String,
    default: null,
  },
});

const emit = defineEmits(['google', 'microsoft', 'saml']);
</script>

<style scoped lang="scss" type="text/scss">
  .sso-buttons {
    ._btn {
      margin-bottom: .4rem;
      background-color: white;
      border-radius: $btn-border-radius;
    }

    ._icon {
      margin-right: .8rem;
    }
  }
</style>
